import React from 'react';
import useTemplateEditorHook from './TemplateEditor.hook.js';
import JoditEditor from 'jodit-react';
import TagInserter from '../../TagInserter/TagInserter.jsx';
import styles from './TemplateEditor.styles';

function TemplateEditor({ value, disabled, onValueChange, tagValues }) {
  const { actions } = useTemplateEditorHook({ tagValues, originalValue: value });

  return (
    <div style={styles.container}>
      <div style={{ marginBottom: 16 }}>
        <TagInserter
          onInsertClicked={actions.insertTag}
          hideTitle
          scope="email_template"
        />
      </div>
      <JoditEditor
        editorRef={actions.setEditorRef}
        value={value}
        config={actions.getEditorConfig(disabled)}
        onChange={v => onValueChange('value', v)}
      />
    </div>
  );
}

export default React.memo(
  TemplateEditor,
  (prev, next) => prev.value === next.value
);
